import React from 'react';
import { useSelector } from 'react-redux';
import AboutUsSection from '../../components/about/AboutUS';
import Img1 from '../../assest/Cranes-1.jpeg';
import Img2 from '../../assest/Cranes-2.jpeg';
import Img3 from '../../assest/Cranes-3.png';
import ServicesSubPages from '../residential/ServicesSubPages';
import ServicesCard from '../../components/home/ServicesCard';
import FaqSection from '../../components/about/FAQ';

const Cranes = () => {
  const { language } = useSelector((state) => state.language) || 'gb';

  const translations = {
    gb: {
      heading: "Our Cranes Service",
      buttonText: "Get In Touch",
      aboutHeading: "About Our Cranes Services",
      aboutText: `At Etihad Gharbia Contracting Company, we provide reliable and safe crane solutions tailored to heavy lifting and logistics needs. Our cranes division supports industries including construction, oil & gas, infrastructure, and utilities.

Our fleet includes mobile, tower, and crawler cranes operated by certified professionals who prioritize safety, precision, and efficiency.`,
      includedHeading: "What’s Included in Our Cranes Services",
      includedItems: [
        "Mobile and tower crane rental",
        "Certified crane operators",
        "Heavy lifting and rigging services",
        "24/7 emergency lifting support",
        "On-site inspection and safety planning",
        "Transportation and logistics for oversized equipment",
        "Hydraulic and telescopic cranes",
        "Compliance with Saudi safety regulations"
      ],
      customizedHeading: "Why Choose Etihad Gharbia for Crane Services",
      customizedItems: [
        "Extensive fleet of modern cranes",
        "Experienced rigging and lifting teams",
        "Full safety compliance and operator certification",
        "Rapid deployment and flexible rental terms",
        "Proven track record in industrial and infrastructure lifting",
        "Tailored lifting plans for complex projects",
        "Support across Saudi Arabia",
        "Transparent pricing and dependable service"
      ]
    },
    sa: {
      heading: "خدمة الرافعات لدينا",
      buttonText: "تواصل معنا",
      aboutHeading: "حول خدمات الرافعات لدينا",
      aboutText: `في شركة اتحاد الغربية للمقاولات، نقدم حلول رافعات آمنة وموثوقة مصممة لتلبية احتياجات الرفع الثقيل والخدمات اللوجستية. تدعم خدمات الرافعات لدينا الصناعات مثل البناء والنفط والغاز والبنية التحتية والمرافق.

يضم أسطولنا رافعات متحركة وبرجية وزاحفة يديرها محترفون معتمدون يركزون على السلامة والدقة والكفاءة.`,
      includedHeading: "ما الذي تتضمنه خدمات الرافعات لدينا",
      includedItems: [
        "تأجير الرافعات المتحركة والبرجية",
        "مشغلو رافعات معتمدون",
        "خدمات الرفع الثقيل والتجهيز",
        "دعم رفع الطوارئ على مدار الساعة",
        "فحص الموقع والتخطيط للسلامة",
        "النقل والخدمات اللوجستية للمعدات الضخمة",
        "رافعات هيدروليكية وتلسكوبية",
        "الامتثال للوائح السلامة السعودية"
      ],
      customizedHeading: "لماذا تختار اتحاد الغربية لخدمات الرافعات",
      customizedItems: [
        "أسطول واسع من الرافعات الحديثة",
        "فرق تجهيز ورفع ذات خبرة",
        "الامتثال الكامل للسلامة وشهادات التشغيل",
        "نشر سريع وشروط تأجير مرنة",
        "سجل حافل في الرفع الصناعي والبنية التحتية",
        "خطط رفع مخصصة للمشاريع المعقدة",
        "دعم في جميع أنحاء السعودية",
        "أسعار شفافة وخدمة موثوقة"
      ]
    },
    fr: {
      heading: "Notre service de grues",
      buttonText: "Contactez-nous",
      aboutHeading: "À propos de nos services de grues",
      aboutText: `Chez Etihad Gharbia Contracting Company, nous proposons des solutions de grues fiables et sécurisées adaptées aux besoins de levage lourd et de logistique. Notre division grues soutient les secteurs de la construction, du pétrole et gaz, des infrastructures et des services publics.

Notre flotte comprend des grues mobiles, à tour et sur chenilles, opérées par des professionnels certifiés axés sur la sécurité, la précision et l'efficacité.`,
      includedHeading: "Ce qui est inclus dans nos services de grues",
      includedItems: [
        "Location de grues mobiles et à tour",
        "Opérateurs de grues certifiés",
        "Services de levage lourd et de gréement",
        "Assistance de levage d'urgence 24h/24",
        "Inspection sur site et planification de la sécurité",
        "Transport et logistique d’équipements surdimensionnés",
        "Grues hydrauliques et télescopiques",
        "Conformité aux normes de sécurité saoudiennes"
      ],
      customizedHeading: "Pourquoi choisir Etihad Gharbia pour les services de grues",
      customizedItems: [
        "Flotte étendue de grues modernes",
        "Équipes expérimentées de levage et de gréement",
        "Conformité totale à la sécurité et certification des opérateurs",
        "Déploiement rapide et conditions de location flexibles",
        "Historique confirmé dans les levages industriels et d'infrastructure",
        "Plans de levage personnalisés pour projets complexes",
        "Soutien dans toute l’Arabie Saoudite",
        "Tarification transparente et service fiable"
      ]
    },
    de: {
      heading: "Unser Krandienst",
      buttonText: "Kontaktieren Sie uns",
      aboutHeading: "Über unsere Krandienstleistungen",
      aboutText: `Die Etihad Gharbia Contracting Company bietet zuverlässige und sichere Kranlösungen für Schwerlast- und Logistikanforderungen. Unsere Kransparte unterstützt Branchen wie Bauwesen, Öl & Gas, Infrastruktur und Versorgungsunternehmen.

Unser Fuhrpark umfasst Mobilkrane, Turmkrane und Raupenkrane, die von zertifizierten Fachleuten betrieben werden, die Sicherheit, Präzision und Effizienz gewährleisten.`,
      includedHeading: "Was ist in unseren Krandienstleistungen enthalten",
      includedItems: [
        "Vermietung von Mobil- und Turmkranen",
        "Zertifizierte Kranführer",
        "Schwerlast- und Rigging-Services",
        "24/7 Notfall-Hebedienste",
        "Vor-Ort-Inspektion und Sicherheitsplanung",
        "Transport und Logistik für Großgeräte",
        "Hydraulik- und Teleskopkrane",
        "Einhaltung der saudischen Sicherheitsvorschriften"
      ],
      customizedHeading: "Warum Etihad Gharbia für Krandienste wählen",
      customizedItems: [
        "Umfangreiche Flotte moderner Krane",
        "Erfahrene Teams für Rigging und Hebetechnik",
        "Vollständige Einhaltung von Sicherheitsvorschriften und Zertifizierungen",
        "Schneller Einsatz und flexible Mietbedingungen",
        "Erfolgreiche Projekte im Industrie- und Infrastrukturbereich",
        "Individuelle Hebepläne für komplexe Projekte",
        "Unterstützung in ganz Saudi-Arabien",
        "Transparente Preise und zuverlässiger Service"
      ]
    }
  };

  const t = translations[language] || translations.gb;

  return (
    <>
      <AboutUsSection
        heading={t.heading}
        buttonText={t.buttonText}
        language={language}
      />
      <ServicesSubPages
        aboutHeading={t.aboutHeading}
        aboutText={t.aboutText}
        images={[Img1, Img2, Img3]}
        includedHeading={t.includedHeading}
        includedItems={t.includedItems}
        customizedHeading={t.customizedHeading}
        customizedItems={t.customizedItems}
      />
      <ServicesCard showHeading={false} showParagraph={false} />
      <FaqSection />
    </>
  );
};

export default Cranes;
